import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export default function PageAnalytics() {
  return (
    <Card className="h-full">
      <CardHeader><CardTitle>Page Analytics</CardTitle><CardDescription>Page visits and time spent by users</CardDescription></CardHeader>
      <CardContent><div className="py-8 text-center text-muted-foreground">Page analytics requires a backend Analytics API. Coming soon.</div></CardContent>
    </Card>
  );
}
